import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-100 dark:bg-gray-800 py-3 px-4 rounded-md my-2 w-full text-center" }
const _hoisted_2 = { class: "appFont" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "appFont text-lg" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "my-5 w-full" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "appFont" }, "100%", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoneyShieldIcon = _resolveComponent("MoneyShieldIcon")!
  const _component_Common = _resolveComponent("Common")!

  return (_openBlock(), _createBlock(_component_Common, {
    showSheet: _ctx.showSheet,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
    title: _ctx.$t('Are you READY?') + ' 😎'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('Choose the one that suits you best')) + " 😁", 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptions, (subscription, i) => {
          return (_openBlock(), _createElementBlock("button", {
            onClick: ($event: any) => (_ctx.select(i)),
            key: subscription,
            class: _normalizeClass(["transition duration-150 bg-gray-100 dark:bg-gray-800 py-3 px-4 rounded-md my-1 w-full text-center hover:bg-gray-200 dark:hover:bg-gray-700", {'bg-primary-300 hover:bg-primary-200 dark:bg-primary-300 dark:hover:bg-primary-200 text-white':_ctx.selected == i, 'focus:bg-gray-300 dark:focus:bg-gray-600': _ctx.selected != i}])
          }, [
            _createElementVNode("span", _hoisted_5, "$" + _toDisplayString(subscription.price), 1),
            _createTextVNode(" " + _toDisplayString(subscription.period) + " ", 1),
            (subscription.most_popular)
              ? (_openBlock(), _createElementBlock("b", _hoisted_6, "(" + _toDisplayString(_ctx.$t('Most popular')) + ")", 1))
              : _createCommentVNode("", true)
          ], 10, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", null, [
          _hoisted_8,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('money back guaranteed until the first week of use')) + " ", 1),
          _createVNode(_component_MoneyShieldIcon)
        ]),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$toast.warning(''))),
          shrink: "",
          class: "transition duration-150 !text-white bg-gradient-to-r from-indigo-500 via-purple-400 to-pink-500 hover:opacity-80 focus:opacity-60 block appFont rounded-lg px-3 py-3 w-full text-center mt-5 mb-3"
        }, _toDisplayString(_ctx.$t('Subscribe')), 1),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('whySub'))),
          class: "bg-gray-100 dark:bg-gray-800 py-3 px-4 rounded-md mt-2 w-full text-center appFont"
        }, _toDisplayString(_ctx.$t('What is this good for?')), 1)
      ])
    ]),
    _: 1
  }, 8, ["showSheet", "title"]))
}